import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import FormFields from "../../components/common/FormFields";
import { COUNTY } from "../../utils/constants";
import {
  createColumn,
  createEditAction,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_COUNTIES } from "../../utils/urls";
import useGet from "../common/useGet";
import { API_DISTRICTS } from "../../utils/apis";

export const useCounties = () => {
  const tableColumns = () => [
    createColumn("name", true, "County"),
    createColumn("district_name", true, "District"),
    createColumn("actions", false, "Actions"),
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        actions: (
          <FormActions actions={[createEditAction(URL_COUNTIES, item?.id)]} />
        ),
      };
    }),
  ];

  const formRoute = getForm(URL_COUNTIES);

  return { tableData, tableColumns, formRoute };
};

export const useCountiesForm = () => {
  const { loadData, loading, data: districtData } = useGet();

  useEffect(() => loadData({ api: API_DISTRICTS }), []);
  const fields: any = [
    {
      field_name: "parent",
      label: "District",
      type: "select",
      props: { required: true },
      options_data: districtData?.results,
      loading,
    },
    {
      field_name: "name",
      label: "County name",
      type: "text",
      props: { required: true },
    },
  ];
  const sections: any = [
    {
      title: "County details",
      fields,
    },
  ];

  const redirect = getRegister(URL_COUNTIES);

  const defaultValues = { location_type: COUNTY };

  return { fields, sections, redirect, defaultValues };
};

export const CountiesForm = ({
  form,
  error,
  updateFormValue,
  onChange,
}: any) => {
  const { fields } = useCountiesForm();
  return (
    <FormFields
      fields={fields}
      error={error}
      form={form}
      updateFormValue={updateFormValue}
      onChange={onChange}
    />
  );
};
